import {
  Stack,
  Paper,
  Typography,
  Button,
  Box,
  Divider,
  Chip,
} from '@mui/material'
import {
  Favorite,
  FavoriteBorder,
  Star,
  StarBorder,
  Scale,
} from '@mui/icons-material'

const EntrySidebar = ({ 
  entry, 
  displayUnit, 
  formatWeight, 
  getUnitLabel, 
  handleToggleFavorite, 
  handleToggleFoundation, 
  onAddWeight 
}) => {
  return (
    <Stack spacing={3}>
      <Paper sx={{ p: 2 }}>
        <Typography variant="h6" gutterBottom>
          Quick Actions
        </Typography>
        <Stack spacing={2}>
          <Button
            variant="outlined"
            startIcon={entry?.isFavorited ? <Favorite /> : <FavoriteBorder />}
            onClick={handleToggleFavorite}
            color={entry?.isFavorited ? "error" : "primary"}
            fullWidth
          >
            {entry?.isFavorited ? 'Remove Favorite' : 'Add to Favorites'}
          </Button>
          <Button
            variant="outlined"
            startIcon={entry?.isFoundation ? <Star /> : <StarBorder />}
            onClick={handleToggleFoundation}
            color={entry?.isFoundation ? "warning" : "primary"}
            fullWidth
          >
            {entry?.isFoundation ? 'Remove Foundation' : 'Mark as Foundation'}
          </Button>
          <Button
            variant="outlined"
            startIcon={<Scale />}
            onClick={onAddWeight}
            fullWidth
          >
            Add Weight
          </Button>
        </Stack>
      </Paper>

      <Paper sx={{ p: 2 }}>
        <Typography variant="h6" gutterBottom>
          Entry Info
        </Typography>
        <Stack spacing={2}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="body2" color="text.secondary">Entry ID</Typography>
            <Typography variant="body2" sx={{ fontFamily: 'monospace' }}>
              {entry?.entryId?.slice(0, 8)}...
            </Typography>
          </Box>
          <Divider />
          {entry?.weights && entry.weights.length > 0 && (
            <>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="body2" color="text.secondary">Current Weight</Typography>
                <Typography variant="body2" sx={{ fontWeight: 'medium' }}>
                  {formatWeight(entry.weights[0].weightGrams || entry.weights[0].weight * 453.592, displayUnit)} {getUnitLabel(displayUnit)}
                </Typography>
              </Box>
              <Divider />
            </>
          )}
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="body2" color="text.secondary">Status</Typography>
            <Box sx={{ display: 'flex', gap: 0.5 }}>
              {entry?.isFavorited && <Chip label="★" size="small" color="secondary" />}
              {entry?.isFoundation && <Chip label="F" size="small" color="primary" />}
              {!entry?.isFavorited && !entry?.isFoundation && (
                <Typography variant="body2">Standard</Typography>
              )}
            </Box>
          </Box>
        </Stack>
      </Paper>
    </Stack>
  )
}

export default EntrySidebar